import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, Typography } from '@mui/material'
import { SkillBiteEditSlice } from '../../../../../reducers'
import { SectionIcon, SessionIcon } from '../../../build/components/icons'
import { TooltipOverflowTitle } from './components/tooltip-overflow-title'
import { useStyles } from './styles'

const SessionSelector = ({ sessions }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const selectedSession = useSelector(SkillBiteEditSlice.selectors.selectSelectedSession)
  const selectedSection = useSelector(SkillBiteEditSlice.selectors.selectSelectedSection)
  const selectedPage = useSelector(SkillBiteEditSlice.selectors.selectSelectedPage)

  const handleChangeSelectedSession = useCallback((session) => {
    if (selectedSession?.id === session?.id) return
    dispatch(SkillBiteEditSlice.actions.changeSelectedSession(session))
  }, [dispatch, selectedSession])

  const handleChangeSelectedSection = useCallback((section) => {
    if (selectedSection?.id === section?.id) return
    dispatch(SkillBiteEditSlice.actions.changeSelectedSection(section))
  }, [dispatch, selectedSection])

  const handleChangeSelectedPage = useCallback((page) => {
    dispatch(SkillBiteEditSlice.actions.changeSelectedPage(page))
  }, [dispatch])

  return (
    <Box>
      <Box className={classes.sessionListContainer}>
        {sessions.map((session, index) => {
          const isSelected = session.id === selectedSession?.id

          return (
            <Accordion
              sx={{
                border: `1px solid ${isSelected ? '#4AA5EF' : '#BCBCBC'}`
              }}
              className={classes.accordion}
              square={false}
              key={index}
              expanded={isSelected}
              onChange={() => handleChangeSelectedSession(session)}
            >
              <AccordionSummary>
                <Box
                  display='flex'
                  flexDirection='row'
                  alignItems='center'
                  className={[classes.sessionItem, isSelected ? 'selected' : ''].join(' ')}
                >
                  <SessionIcon />
                  <TooltipOverflowTitle
                    title={session.name}
                    minCharTooltip={30}
                    typographySx={{ fontWeight: isSelected ? 600 : 400, flex: 1 }}
                  />
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Box>
                  <Typography sx={{ fontWeight: 600 }}>Sections</Typography>
                  <Divider />
                  <Box display='flex' flexDirection='column' gap={1} pt={1}>
                    {session.sections.map((section, sectionIndex) => {
                      const isSectionSelected = section.id === selectedSection?.id
                      return (
                        <>

                          <Box
                            key={sectionIndex}
                            display='flex'
                            flexDirection='row'
                            alignItems='center'
                            className={classes.sectionItem}
                            onClick={() => handleChangeSelectedSection(section)}
                          >
                            <SectionIcon />
                            <TooltipOverflowTitle
                              title={section.name}
                              minCharTooltip={27}
                              typographySx={{ fontWeight: isSectionSelected ? 600 : 400, flex: 1 }}
                            />
                          </Box>
                          <Box>
                            {isSectionSelected && (
                              <Box component='ul' sx={{ margin: 0 }}>
                                {section.pages.map((page, pageIndex) => {
                                  const isPageSelected = page.id === selectedPage?.id
                                  return (
                                    <Box
                                      key={pageIndex}
                                      component='li'
                                      className={classes.pageItem}
                                      sx={{ marginBottom: '8px', '::marker': { color: isPageSelected ? '#000' : '#777' } }}
                                      onClick={() => handleChangeSelectedPage(page)}
                                    >
                                      <Typography
                                        className={classes.pageItem}
                                        sx={{ fontWeight: isPageSelected ? 600 : 400 }}
                                      >
                                        Page {pageIndex + 1}
                                      </Typography>
                                    </Box>
                                  )
                                })}
                              </Box>
                            )}
                          </Box>
                        </>
                      )
                    })}
                  </Box>
                </Box>
              </AccordionDetails>
            </Accordion>
          )
        })}
      </Box>
    </Box>
  )
}

export default SessionSelector
